import React from 'react';
import StatusTabs from '../../shared/StatusTab';
import MediaList from '../../shared/MediaList';

const MangaCollection = ({
  collection,
  activeTab,
  setActiveTab,
  isLoading,
  statuses
}) => {
  // Find the current status label
  const currentStatusLabel = statuses.find(s => s.key === activeTab)?.label || 'Manga';
  
  return (
    <>
      {/* Manga Status Tabs */}
      <StatusTabs 
        statuses={statuses}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        collection={collection}
      />
      
      {/* Manga List */}
      <MediaList 
        items={collection[activeTab] || []}
        isLoading={isLoading}
        mediaType="manga"
        activeStatus={activeTab}
        statusLabel={currentStatusLabel}
      />
    </>
  );
};

export default MangaCollection;